import axiosInstance from '@/plugins/api/axiosInstance';

export default function company() {
    const appUrl = import.meta.env.VITE_APP_URL;
    return {
        config: config,
        formTemplate: formTemplate,
        search,
        update,
        getCompanyLoginStyles
    };

    function config() {
        return axiosInstance.get(`company/config`);
    }

    function formTemplate() {
        return axiosInstance.get(`company/form-template`);
    }

    function search() {
        return axiosInstance
            .get('company/get')
            .then((response) => {
                return {
                    total: 1,
                    data: [response]
                };
            })
            .catch(() => {
                return {
                    total: 0,
                    data: []
                };
            });
    }

    function update(payload) {
        let data = new FormData();
        for (let key in payload) {
            if (Array.isArray(payload[key])) {
                payload[key].forEach((item, index) => {
                    data.append(`${key}[${index}]`, item);
                });
            } else {
                data.append(key, payload[key]);
            }
        }

        const config = {
            method: 'post',
            url: 'company/update',
            headers: {
                'Content-Type': `multipart/form-data`
            },
            data: data
        };

        return axiosInstance(config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error.data;
            });
    }

    function getCompanyLoginStyles(acronym) {
        return axiosInstance.get(
            `${appUrl}/public/company-theme?company=${acronym}`
        );
    }
}
